<div class="error-message--wrapper" *ngIf="message">
    <div class="input-field-error-msg" [ngClass]="isClassPresent ? isClassPresent  : '' ">
        <p class="error-icn">
            <i class="icon-icon-error"></i>
        </p>
        <p class="error-desc">
            {{message}}
        </p>
        <p class="error-close" *ngIf="isShowCloseMark" (click)="closeErrorMessage()">
            <i class="icon-cancel-1"></i>
        </p>
    </div>
</div>